// src/routes/dashboard/dashboardRoutes.js
import { combinePathRoutes } from "src/helpers";
import routes from "src/routes";
import { lazy } from "react";


// Lazy imports
const DashboardHome = lazy(() => import("../components/Home"));

// Route definitions
export const dashboard = {
  path: "/dashboard",
  component: DashboardHome,
};



// Combine base path
const path = routes.admin.path;

export default combinePathRoutes(
  { path },
  {
    dashboard
  }
);
